// extracted by mini-css-extract-plugin
export default {"container":"ProductTitle_container__x-Hwk","title":"ProductTitle_title__iQu0I","price":"ProductTitle_price__j0w0e"};